<template>
    <div class="text-primary mt-3">
        <div v-text="'Plomba powinna:'" class="font-weight-bold text-sm mb-2" />
        <ul class="list-unstyled text-sm mb-0">
            <li
                v-for="requirement in requirements"
                :key="requirement.key"
                class="d-flex align-items-center mb-2"
            >
                <a-icon
                    width="16"
                    class="mr-2"
                    :icon="requirement.valid ? 'Ok' : 'ErrorCircle'"
                />
                <span v-text="requirement.label" />
                <a-icon
                    v-if="requirement.tooltip"
                    v-tooltip="requirement.tooltip"
                    icon="Info"
                    height="16"
                    class="ml-1"
                />
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        requirements: {
            type: Array,
            required: true
        }
    }
}
</script>
